import { ref, computed } from 'vue'
import type { Ref } from 'vue'
import { useNewsVideoHeadlines } from './useNewsVideos'
import type { SearchParamsNewsCategory } from '../../utils/newsCategoryTab'

export function useConditionalNewsVideos(
  category: Ref<SearchParamsNewsCategory>,
  skeleton: Ref<LayoutSkeleton | undefined>
) {
  const requiresVideos = computed(() => {
    if (!skeleton.value) return false

    return skeleton.value.section.some((section) =>
      section.titles?.some(
        (title) =>
          'type' in title &&
          (title.type?.startsWith('video') ||
            title.props?.contentType === 'video')
      )
    )
  })

  if (!requiresVideos.value) {
    return {
      videoHeadlines: ref([]),
      status: ref(null),
      error: ref(null),
      hasMore: ref(false),
      count: ref(0),
      fetchNextPage: async () => {},
    }
  }

  return useNewsVideoHeadlines(category)
}
